var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.gym)?_c('publication-list',{attrs:{"publishable":_vm.gym,"publishable-type":"Gym"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }